import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { getBaseUrl } from '@env/utils';

export function HttpTranslateLoaderFactory(
  client: HttpClient
): TranslateLoader {
  return new HttpTranslateLoader(client);
}

export class HttpTranslateLoader implements TranslateLoader {
  cache: { [key: string]: any } = {};

  constructor(private readonly client: HttpClient) {}

  public getTranslation(lang: string): Observable<any> {
    if (this.cache[lang]) {
      // of, not from: what is cached is the parsed translation object, and from() on a plain object throws
      // "You provided an invalid object where a stream was expected" rather than emitting it.
      return of(this.cache[lang]);
    }
    return this.client
      .get(`${getBaseUrl()}/api/translation/` + lang)
      .pipe(tap((resp) => (this.cache[lang] = resp)));
  }
}
